<div class="ps_formBuilder_formContainer" fxLayoutAlign="center center">

  <div fxLayout="row" *ngIf="field.type == 'textfield'">
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label *ngIf="field.label">{{ field.label }}</mat-label>
      <input #inputField matInput [formControl]="form" [placeholder]="field.placeholder" [maxlength]="field.size" (input)="onInputChange()"/>
      <mat-hint *ngIf="field.hint">{{field.hint}}</mat-hint>
      <mat-hint align="end" *ngIf="field.size">{{inputField.value.length}}/{{field.size}}</mat-hint>
    </mat-form-field>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
  </div>

  <div fxLayout="row" *ngIf="field.type == 'number'">
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label *ngIf="field.label">{{ field.label }}</mat-label>
      <input matInput type="number" [formControl]="form" [placeholder]="field.placeholder" />
      <mat-hint *ngIf="field.hint">{{field.hint}}</mat-hint>
    </mat-form-field>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
  </div>

  <div fxLayout="row" *ngIf="field.type == 'textarea'">
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label *ngIf="field.label">{{ field.label }}</mat-label>
      <textarea #inputField matInput [formControl]="form" [placeholder]="field.placeholder"></textarea>
      <mat-hint *ngIf="field.hint">{{field.hint}}</mat-hint>
      <mat-hint align="end" *ngIf="field.size">{{inputField.value.length}}/{{field.size}}</mat-hint>
    </mat-form-field>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
  </div>

  <div fxLayout="row" *ngIf="field.type == 'select'">
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label *ngIf="field.label">{{ field.label }}</mat-label>
      <mat-select [formControl]="form" [placeholder]="field.placeholder">
        <mat-option *ngFor="let option of field.options" [value]="option.value">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="field.hint">{{field.hint}}</mat-hint>
    </mat-form-field>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
  </div>

  <div style="display: flex;" *ngIf="field.type == 'toogle'">
    <mat-slide-toggle [formControl]="form" *ngIf="field.type == 'toogle'" [color]="'primary'">
      {{ field.label }}
    </mat-slide-toggle>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
    <mat-icon *ngIf="field.key === 'hidde' && form.value" matTooltip="Este campo ficará oculto"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-content" class="ps-option-badge-icon">visibility_off
    </mat-icon>
  </div>

  <div *ngIf="field.type == 'radio'">
    <label *ngIf="field.label" id="label">{{ field.label }} </label>
    <mat-icon class="ps_formBuilder_tooltipIcon" *ngIf="field.tooltip" [matTooltip]="field.tooltip"
      matTooltipPosition="after" matTooltipClass="ps-tooltip-preLined-content" svgIcon="help"></mat-icon>
    <mat-radio-group [formControl]="form" class="ps_formBuilder_radioGroup" aria-labelledby="label">
      <mat-radio-button class="ps_formBuilder_radioButton" *ngFor="let option of field.options" [value]="option.value">
        {{ option.name }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

</div>
